"use client";

import { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { ListItem } from "@mui/material";

const CustomListItem = ({
  href,
  children,
}: {
  href: string;
  children: ReactNode;
}) => {
  const pathname = usePathname();
  const color = pathname === href ? "text-white" : "text-neutral-300";
  const bgColor = pathname === href ? "bg-primary-900" : "bg-brand-1";
  return (
    <ListItem
      className={`
        h-10 w-10 p-0 rounded-lg overflow-hidden bg-brand-1
        transition-all
        ${color}
        hover:w-40
        ${bgColor}
        hover:text-white
      `}
    >
      {children}
    </ListItem>
  );
};

export default CustomListItem;
